import { PaginationFilterRequest } from '@/models/core.model';
export interface User {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  isPhoneVerified: boolean;
  isEmailVerified: boolean;
  phoneNumber?: string;
  email?: string;
  profilePicture?: string;
  gender?: GenderEnum;
  role: RoleEnum;
  lastLogin?: string;
}

export interface UpsertUser {
  id?: number;
  username?: string;
  phoneNumber?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  profilePicture?: string;
  role: RoleEnum;
  gender?: GenderEnum;
  password?: string;
  confirmPassword?: string;
  isPhoneVerified: boolean;
  isEmailVerified: boolean;
}

export interface UserLookup
{
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  profilePicture?: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse extends User {
  token: string
}

export class UserPaginationFilterRequest extends PaginationFilterRequest {
  role?: number;
}

export enum RoleEnum {
  User = 0,
  Support = 1,
  Admin = 2,
  ThirdParty = 3,
}
export enum GenderEnum {
  NotSpecified,
  Male,
  Female,
  Diverse
}


export const UserGenderList = [
  { value: 0, label: "Not Specified" },
  { value: 1, label: "Male" },
  { value: 2, label: "Female" },
  { value: 3, label: "Diverse" },
];
export const UserRolesList = [
  { value: 0, label: "User" },
  { value: 1, label: "Support" },
  { value: 2, label: "Admin" },
  { value: 3, label: "Third Party" },
];
